import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy
} from '@angular/core';
import { ItemPivotModel } from 'src/app/items/item-pivot.model';
import { ItemsService } from 'src/app/items/items.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-contractors-items-view',
  templateUrl: './contractors-items-view.component.html',
  styleUrls: ['./contractors-items-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ContractorsItemsViewComponent implements OnInit {
  pivot: ItemPivotModel = new ItemPivotModel();
  public name: string;

  constructor(
    private itemService: ItemsService,
    @Inject(MAT_DIALOG_DATA) private id: number
  ) {}

  ngOnInit() {
    this.itemService
      .findPivot(this.id)
      .subscribe((response) => (this.pivot = response.data));
  }

  getExpiryClass(expiresAt: number): string {
    const now = Date.now();
    const expiryDate = expiresAt * 1000;
    const daysUntilExpiry = (expiryDate - now) / (1000 * 60 * 60 * 24);

    if (daysUntilExpiry < 0) {
      return 'expiry-expired';
    }

    if (daysUntilExpiry <= 7) {
      return 'expiry-warning';
    }

    return 'expiry-valid';
  }
}
